import CommentItem from './Item'
import type { Comment } from '.'

const CommentList = ({ comments, reload }: { comments: Comment[], reload: any }) => {
  return (
    <div className="">
      {comments.map((comment) => (
        <CommentItem key={comment.id} comment={comment} reload={reload} />
      ))}
    </div>
  );
};

export default CommentList;
